import webBackApi from '../../api/webBackApi';

export const getAllDiscountDaysLogs = async () => {
  try {
    const response = await webBackApi.get('/api/discount-days-logs');
    return response.data;
  } catch (error) {
    console.error("Error fetching discount days logs:", error);
    throw error;
  }
};

export const getFailedDiscountDaysLogs = async () => {
  try {
    const response = await webBackApi.get('/api/discount-days-logs/failed');
    return response.data;
  } catch (error) {
    console.error("Error fetching failed discount days logs:", error);
    throw error;
  }
};
